/* global Word */
/* global Office */
export async function getDocumentProperties(): Promise<Word.Interfaces.DocumentPropertiesData> {
  await Office.onReady();
  return Word.run(async (context) => {
    const builtInProperties: Word.DocumentProperties = context.document.properties;
    builtInProperties.load("*");

    await context.sync();
    return builtInProperties.toJSON();
  });
}
